import React from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Import Link from react-router-dom
import './footer.css';

function Footer() {
    const navigate = useNavigate();

    return (
        <footer className="footer">
            <div className="footer-content">
                <p>© 2025 Loading Leaves</p>
                <p>
                    <a href="https://docs.google.com/document/d/1bwqOLIJsWkiObHdIqTe1NzEezclDiF0fRw_kF8oi7w4/edit?usp=sharing"
                        style={{ textDecoration: 'none', color: '#FFFFFF' }}>
                        プライバシーポリシー
                    </a>
                </p>
                <div className="footer-links">
                    <a href="https://www.instagram.com/loading_leaves.app/" target="_blank" rel="noopener noreferrer" className="footer-link">
                        Instagram
                    </a>
                    <a href="https://loadingleaves2024.studio.site/" target="_blank" rel="noopener noreferrer" className="footer-link">
                        Loading Leavesについて
                    </a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;